module.exports = __webpack_public_path__ + "img/news-inner-image.f3a90382.jpg";